import axios from 'axios';
import { buildApiUrl } from '../config/api';

const API = buildApiUrl();

const parsePayload = (payload) => {
  if (!payload) return undefined;
  if (typeof payload === 'string') {
    try {
      return JSON.parse(payload);
    } catch (err) {
      return payload;
    }
  }
  return payload;
};

if (process.env.NODE_ENV === 'development' && !axios.__LOG_INTERCEPTORS_ATTACHED__) {
  axios.interceptors.request.use((config) => {
    const method = (config.method || 'GET').toUpperCase();
    const url = config.baseURL ? `${config.baseURL}${config.url || ''}` : config.url;
    return config;
  });

  axios.interceptors.response.use((response) => {
    const method = (response.config?.method || 'GET').toUpperCase();
    const url = response.config?.baseURL ? `${response.config.baseURL}${response.config.url || ''}` : response.config?.url;
    return response;
  }, (error) => {
    const method = (error.config?.method || 'GET').toUpperCase();
    const url = error.config?.baseURL ? `${error.config.baseURL}${error.config.url || ''}` : error.config?.url;
    const status = error.response?.status;
    const data = parsePayload(error.response?.data) || error.message;
    // eslint-disable-next-line no-console
    console.error('[API ERROR]', method, url, status, data);
    return Promise.reject(error);
  });

  Object.defineProperty(axios, '__LOG_INTERCEPTORS_ATTACHED__', {
    value: true,
    writable: false
  });
}

const authService = {
  signup: async (data) => {
    const res = await axios.post(`${API}/users/auth/register-email/`, data);
    return res.data;
  },
  verifyEmail: async (email, code) => {
    const res = await axios.post(`${API}/users/auth/verify-email/`, { email, code });
    return res.data;
  },
  requestOtp: async (data) => {
    const res = await axios.post(`${API}/users/auth/request-otp/`, data);
    return res.data;
  },
  verifyOtp: async (data) => {
    const res = await axios.post(`${API}/users/auth/verify-otp/`, data);
    const payload = res.data || null;
    if (payload?.access) {
      const store = { ...payload, token: payload.access };
      try {
        localStorage.setItem('user', JSON.stringify(store));
      } catch (err) {
        // ignore storage errors
      }
    }
    return payload;
  },
  resendVerification: async (email) => {
    const res = await axios.post(`${API}/users/auth/resend-email/`, { email });
    return res.data;
  },
  requestPasswordReset: async (email) => {
    const res = await axios.post(`${API}/users/auth/password-reset/request/`, { email });
    return res.data;
  },
  verifyPasswordResetCode: async (email, code) => {
    const res = await axios.post(`${API}/users/auth/password-reset/verify/`, { email, code });
    return res.data;
  },
  resetPasswordWithCode: async ({ email, code, password }) => {
    const res = await axios.post(`${API}/users/auth/password-reset/confirm/`, {
      email,
      code,
      new_password: password,
    });
    return res.data;
  },
  login: async (credentials) => {
    const res = await axios.post(`${API}/users/auth/token/`, credentials);
    const payload = res.data ? {
      ...res.data,
      token: res.data.access,
    } : null;

    if (payload?.access) {
      localStorage.setItem('user', JSON.stringify(payload));
    }

    return payload;
  },
  logout: () => {
    localStorage.removeItem('user');
  },
  getCurrentUser: () => {
    try {
      const u = localStorage.getItem('user');
      return u ? JSON.parse(u) : null;
    } catch (err) { return null; }
  }
};

export default authService;
